import type { Message } from "../types";

interface MessageBubbleProps {
  message: Message;
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isAssistant = message.role === "assistant";

  return (
    <div className={`message ${isAssistant ? "message--assistant" : "message--user"}`}>
      <div className="message__header">
        {isAssistant ? (
          <div className="message__avatar message__avatar--assistant">
            <img src="/assets/icon-64.png" alt="" />
          </div>
        ) : (
          <div className="message__avatar message__avatar--user">Du</div>
        )}
        <span className="message__label">
          {isAssistant ? "Lio" : "Du"}
        </span>
      </div>
      <div className="message__content">
        {message.content || (message.streaming ? "" : "(Leer)")}
        {message.streaming && <span className="message__cursor" />}
      </div>
    </div>
  );
}
